import gql  from "graphql-tag";

const GET_POOL_QUIZ_VIDEOS = gql`
    query getPoolQuizzes (
        $poolId: String!
    ) {
        getPoolQuizzes (
            getPoolQuizzesInput: {
                poolId: $poolId
            }
        ){
            id
            lessonType
            lessonContent
            poolId
        }
    }
`

export default GET_POOL_QUIZ_VIDEOS;